import { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./openChatsStyle.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";

export default function Settings() {
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const eventId = searchParams.get("eventId");

    const [chats, setChats] = useState([]);

    useEffect(() => {
        document.title = "DJ - EMAN"

        getChats();
    }, []);

    const getChats = async () => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/open-chats?token=" + Cookies.get("token") + "&eventId=" + eventId, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                const data = await response.json();
                setChats(data);
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    function switchSide(side) {
        navigate(side);
    }

    return (
        <div className="openChatsContainer">
            <ToastContainer
                theme="dark"
            />
            <h1>Chats</h1>
            <img className="backArrow" onClick={() => switchSide("/musicrequestevent?id=" + eventId)}src="/img/arrowLeft.svg" />
            {chats.map((chat) => (
                <div className="chatContainer" onClick={() => switchSide(`/chat?eventId=${chat.eventId}&ownerId=${chat.ownerId}&name=${chat.name}`)}>
                    <h1>{chat.name}</h1>
                </div>
            ))}
        </div>
    )
}
